import Vue from 'vue';

Vue.component('black-background-color-inverter', {
    props: {},

    data() {
        return {
            showMenu: false,
        };
    },

    async mounted() {
        this.invertNavigationColor(this.showMenu);
        this.invertFooterColor();
    },

    destroyed() {},

    watch: {
        '$root.showMenu': function (value) {
            this.showMenu = value;
            this.invertNavigationColor(value);
        },
        '$root.showCountries': function (value) {
            this.showMenu = value;
            this.invertNavigationColor(value);
        },
    },

    methods: {
        invertFooterColor() {
            this.changeFooterContainerColor();
            this.changeFooterLogoColor();
            this.changeFooterItemsColor();
            this.changeFooterDisclaimerColor();
            this.changeFooterSliderColor();
            this.changeEnergyLabelsColor();
            this.changeSwedenLoanDisclaimerColor();
        },

        invertNavigationColor(isMenuOpen) {
            this.changeNavigationContainerColor(isMenuOpen);
            this.changeNavigationItemsColor(isMenuOpen);
            this.changeLogoColor(isMenuOpen);
            this.changeHamburgerMenuColor(isMenuOpen);
        },

        changeNavigationContainerColor(isMenuOpen) {
            const container = document.querySelector('.header-container');
            container.style.backgroundColor = isMenuOpen ? '#f7f7f7' : 'black';
            container.style.paddingBottom = '2px';

            const navigationDropdowns = document.querySelectorAll(
                '.main-navigation-new-children ',
            );
            const navigationDropdownArrows = document.querySelectorAll(
                '.main-navigation-new__arrow-down',
            );

            if (navigationDropdowns) {
                navigationDropdowns.forEach((dropdown) => {
                    dropdown.classList.add('--black');
                });
            }
            if (navigationDropdownArrows) {
                navigationDropdownArrows.forEach((arrow) => {
                    arrow.style.borderColor = 'white';
                });
            }
        },

        changeNavigationItemsColor(isMenuOpen) {
            const allContainerItems = document.querySelectorAll(
                '.main-navigation-new__item',
            );
            const allLinkItems = document.querySelectorAll(
                '.main-navigation-new__item-link',
            );
            const countryButton = document.querySelectorAll(
                '.header__country-selector',
            );
            allContainerItems.forEach((item) => {
                item.style.setProperty(
                    '--bg-color',
                    isMenuOpen ? 'black' : 'white',
                );
            });
            allLinkItems.forEach((item) => {
                item.style.color = isMenuOpen ? 'black' : 'white';
            });
            countryButton.forEach((item) => {
                item.style.color = isMenuOpen ? 'black' : 'white';
            });
        },

        changeLogoColor(isMenuOpen) {
            const allLogos = document.querySelectorAll('#logo-icon--black');
            const globe = document.querySelector('#logo-icon-globe');

            if (allLogos) {
                allLogos.forEach((logo) => {
                    isMenuOpen
                        ? logo.classList.remove('logo-icon--white')
                        : logo.classList.add('logo-icon--white');
                });
            }

            if (globe) {
                isMenuOpen
                    ? globe.classList.remove('globe-icon--white')
                    : globe.classList.add('globe-icon--white');
            }
        },

        changeFooterLogoColor() {
            const allLogos = document.querySelectorAll('#logo-icon--black');

            if (!allLogos) return;
            allLogos.forEach((logo) => {
                logo.classList.add('logo-icon--white');
            });
        },

        changeHamburgerMenuColor(isMenuOpen) {
            const allItems = document.querySelectorAll('.hamburger__line');
            allItems.forEach((item) => {
                item.style.backgroundColor = isMenuOpen ? 'black' : 'white';
            });
        },

        changeFooterContainerColor() {
            const container = document.querySelector('#footer-v2');
            container.style.backgroundColor = 'black';
        },

        changeSwedenLoanDisclaimerColor() {
            const container = document.getElementById('footer-loan-disclaimer');
            if (!container) return;

            const textContainer = container.querySelector(
                '.footer-loan-disclaimer__text',
            );
            if (!textContainer) return;

            const h3Element = textContainer.querySelector('h3');
            const pElement = textContainer.querySelector('p');
            if (h3Element) h3Element.style.color = 'white';
            if (pElement) pElement.style.color = '#ffffff90';
        },

        changeFooterItemsColor() {
            const allItems = document.querySelectorAll('.footer-link');
            allItems.forEach((item) => {
                item.style.color = 'white';
                item.style.setProperty('--bg-color', 'white');
            });
        },

        changeFooterDisclaimerColor() {
            const disclaimers = document.querySelectorAll('#footer-disclaimer');
            if (!disclaimers) return;

            disclaimers.forEach((disclaimer) => {
                disclaimer.style.color = 'white';
            });
        },

        changeFooterSliderColor() {
            const slider = document.querySelector('.footer-slider');
            if (slider) slider.style.color = 'white';
        },

        changeEnergyLabelsColor() {
            const energyLabels = document.getElementById('energy-labels');
            if (energyLabels) energyLabels.classList.add('black');
        },
    },
});
